import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import { useUserDeviceUuid } from '@/components/Functional/hooks-core/useUserDeviceUuid'
import { convertLanguage } from '@/components/Functional/utils/convertLanguage'
import {
  type CampaignHeaders,
  type CampaignHeadersWithAuthorization,
  getHeaders,
  getHeadersWithAuthorization,
} from '@/components/Functional/utils/getHeader'
import { useTokenStore } from '@/store/useTokenStore'

/**
 * headers: Authorizationなしのヘッダー
 * headersWithAuthorization: Authorizationありのヘッダー
 */
export const useCampaignHeaders = (): {
  headers: CampaignHeaders
  headersWithAuthorization: CampaignHeadersWithAuthorization
} => {
  const { LOCAL_STORAGE_I18N_KEY, campaignSlug } = useCampaignSlug()
  const { uuid } = useUserDeviceUuid()
  const idToken = useTokenStore((s) => s.idToken)
  if (typeof window === 'undefined') {
    return {
      headers: getHeaders({ campaignSlug, uuid, locale: 'ja_JP' }),
      headersWithAuthorization: getHeadersWithAuthorization({ campaignSlug, uuid, locale: 'ja_JP', idToken: '' }),
    }
  }

  const detectedLng = convertLanguage(navigator.language)
  const locale = localStorage.getItem(LOCAL_STORAGE_I18N_KEY) || detectedLng || 'ja_JP'
  return {
    headers: getHeaders({ campaignSlug, uuid, locale }),
    headersWithAuthorization: getHeadersWithAuthorization({ campaignSlug, uuid, locale, idToken: idToken || 'none' }),
  }
}
